export default __webpack_public_path__ + "static/media/KRA_targets.714c99be.csv";